import CustomAvatar from "@/components/CustomAvatar";
import LoadingSpinner from "@/components/LoadingSpinner";
import MainLayout from "@/lib/layout/MainLayout";
import { useFollowing } from "@/lib/tanstack-query/hooks/useFollowing";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

export const Route = createFileRoute("/_dashboard/following/$username")({
  component: RouteComponent,
});

function RouteComponent() {
  const { ref, inView } = useInView();
  const { username } = Route.useParams();

  const {
    data: following,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useFollowing(username);

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView, isLoading]);

  return (
    <>
      <MainLayout.Header headline="Following"></MainLayout.Header>
      <div className={"border-border-wu divide-y"}>
        {following?.pages.flatMap((followees) => {
          return followees.map((followee) => {
            return (
              <Link
                to="/profile/$username"
                key={followee.id}
                params={{
                  username: followee.username,
                }}
                className="hover:bg-button-hover-background-wu flex w-full items-center space-x-3 px-4 py-4 transition-colors md:px-6 dark:text-white"
              >
                <CustomAvatar
                  width="40px"
                  height="40px"
                  name={followee.name}
                  avatarString={followee.avatar}
                  image={followee.image}
                />
                <div className="flex-1 text-left">
                  <div className="font-medium dark:text-white">
                    {followee.name}
                  </div>
                  <div className="text-secondary-text-wu text-sm">
                    @{followee.username}
                  </div>
                </div>
              </Link>
            );
          });
        })}
      </div>
      <div>
        {isLoading ? <LoadingSpinner /> : null}
        {hasNextPage ? <LoadingSpinner ref={ref} /> : null}
      </div>
    </>
  );
}
